<!--
  The whole "Crew" card-section moved from the parent (performance-card)
  into this child component so we can collapse the title together with
  the body when there's nothing to show. Previous design left an orphan
  "Crew" heading on the dashboard for shows without any crew configured.

  Two visible states inside the @if:
    - Loading  → calm "Crew laden…" placeholder so the dashboard
                  doesn't flash a wrong list while users + showreport +
                  roleTypes resolve.
    - Dynamic  → roleTypes-driven list with crew names from the
                  showreport (or "-" placeholders for unassigned roles).

  When neither holds (post-load + no data) `hasContent` is false, the
  @if collapses, and the parent's card-section gap closes naturally.

  The legacy 5-role hardcoded list was removed; every show now goes
  through the dynamic path. Component still carries the legacy
  resolver methods marked @deprecated for one sprint.
-->

@if (hasContent) {
  <div class="card-section">
    <b class="card-section-title">{{ 'performanceCard.crew.title' | translate }}</b>

    <div class="crew">
      @if (isLoading) {
        <ul class="crew-loading">
          <li>
            <span class="crew-loading-text">{{ 'performanceCard.crew.loading' | translate }}</span>
          </li>
        </ul>
      } @else {
        <ul>
          @for (crew of dynamicCrewMembers; track crew) {
            <li>
              <span class="role-name">
                {{ crew.label }}
                @if (crew.hasEarlyShift) {
                  <ion-icon class="early-shift-icon" name="alarm-outline" />
                }
              </span>
              <span class="crew-name" [class.crew-name--unassigned]="!crew.isFromShowreport">
                @if (crew.isFromShowreport) {
                  {{ crew.userName }}
                } @else {
                  -
                }
              </span>
            </li>
          }
        </ul>
      }
    </div>
  </div>
}
